import React,{useEffect,useState} from "react";
import CustomHeading from "../../../constants/CustomHeading";
import {connect} from 'react-redux';
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomBox from "../../../constants/CustomBox";
import CustomReportTable from "./CustomReportTable";
import CustomFilter from "../../../constants/CustomFilter";
import {getCourseCurriculumData,getorganizationData,getCurriculumData,getProgramOutcomeData,getBloomsLevelData} from "../../../redux/actions/dataAction";
const DepartmentCurriculumReport = (props) => {
  useEffect(()=>{
    props.getCourseCurriculumData()
    props.getorganizationData();
    props.getProgramOutcomeData();
    props.getCurriculumData();
    props.getBloomsLevelData();
    console.log(props?.course_curriculum?.data)
  },[])
  	const [filter,setFilter]=useState({
    term:'Select Term',
    curriculum:'Select Curriculum',
    course:'Select Course'
  })
  	const handleChange=(event)=>{
    	setFilter({...filter,[event.target.id]:event.target.value}) 
  	}
  	const curriculums=[]
	for(var i=0;i<props?.curriculums?.data.length;i++){
  		curriculums.push({value:props?.curriculums?.data[i].name})
	}
  return (
    <div className="customContainer mb-5">
      <CustomHeading title="Department / Curriculum Report" />
		<CustomDropdown
            label="Curriculum: :"
             data={curriculums}
             notDefaultOption
             id="curriculum"
            defaultOption={"Select Curriculum:"}
            onChange={handleChange}
          />
        <CustomBox title="Vision :" details={props?.organization?.data?.vision}/>
    	<CustomBox title="Mission :" details={props?.organization?.data?.mission}/>
    	{props?.programOutcome!=undefined?<CustomReportTable title="Program Educational Outcome" 

    	index1={CustomFilter(props?.programOutcome?.data,[{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]).map((data,index)=>(`PEO${index+1}`))}

    	index2={CustomFilter(props?.programOutcome?.data,[{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]).map((data,index)=>(data.statement))}
    	 />:''}

    	{props?.programOutcome!=undefined?<CustomReportTable title="Program Outcomes" 

    	index1={CustomFilter(props?.programOutcome?.data,[{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]).map((data,index)=>(`Outcome\"PO${index+1}\"`))}

    	index2={CustomFilter(props?.programOutcome?.data,[{value:filter.curriculum,label:'curriculum',initial_value:'Select Curriculum'}]).map((data,index)=>(data.po_reference))}
    	 />:''}

    	{props?.bloomLevel!=undefined?<CustomReportTable title="Bloom's Level Taxonomy"
    	headerTitle={["Sl. No.","Level of Learning","Characteristics of Learning","Verbs in Questions or Learning Outcomes"]}
    	index3={props?.bloomLevel.data?.map((data,index)=>(`${index+1}`))}
    	index4={props?.bloomLevel.data?.map(data=>(data.level_of_learning))}
    	index5={props?.bloomLevel.data?.map(data=>(data.characteristics_of_learning))}
    	index6={props?.bloomLevel.data?.map(data=>(data.action_verb))}/>:''}

    </div>
  );
};
const mapActionWithProps = {
  getCourseCurriculumData,
  getCurriculumData,
  getorganizationData,
  getProgramOutcomeData,
  getBloomsLevelData
}
const mapStateWithProps = (state)=>(
  {
    course_curriculum:state.data.course_curriculum,
    curriculums:state.data.curriculums,
    organization:state.data.organisation,
    programOutcome:state.data.programOutcome,
    bloomLevel:state.data.bloomLevel
  }
)
export default connect(mapStateWithProps,mapActionWithProps)(DepartmentCurriculumReport);
